{
    "action__edit": "Bearbeiten",
    "action__copy_contact": "Kontakt kopieren"
}
